import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { ServerUsers } from '../resources/ServerUsers';
import { IResult } from '../ServerApi/types/IResponse';
import { IServerUser } from '../ServerApi/types/IServerUser';
import { ISiteUser } from '../ServerApi/types/ISiteUser';
import { IUser } from '../ServerApi/types/IUser';
import { IUserActionResult, UserActionResultCode } from '../ServerApi/types/IUserActionResult';
import { ConfirmActionDialog } from './ConfirmActionDialog';
import { ConfirmationBasedAction, ConfirmationBasedActionMetadata } from './ConfirmationBasedAction';
import { UserActionNotification, UserActionNotificationParams } from './UserActionNotification';

export class ResetLoginRateLimitingAction {

  public static $inject = ['$translate',
                           'ConfirmActionDialog',
                           'UserActionNotification',
                           'ServerUsers'];

  private static DIALOG_BODY: string = 'confirmResetLoginRateLimiting';
  private static DIALOG_TITLE: string = 'resetLoginRateLimitingTitle';
  private static ACTION_NAME: string = 'confirmResetLoginRateLimitingButton';

  private confirmationBasedSiteAction: ConfirmationBasedAction;
  private confirmationBasedServerAction: ConfirmationBasedAction;

  constructor(
    private $translate: ng.translate.ITranslateService,
    private ConfirmActionDialog: ConfirmActionDialog,
    private userActionNotification: UserActionNotification,
    private ServerUsers: ServerUsers) {
    this.confirmationBasedSiteAction =
      this.createAction(this.ServerUsers.resetLoginRateLimitingOnSiteUsers.bind(this.ServerUsers));
    this.confirmationBasedServerAction =
      this.createAction(this.ServerUsers.resetLoginRateLimiting.bind(this.ServerUsers));
  }

  private createAction(requestTrigger: (userIds: string[]) => ng.IPromise<IUserActionResult>):
      ConfirmationBasedAction {
    const actionMetadata: ConfirmationBasedActionMetadata = {
      dialogBody: ResetLoginRateLimitingAction.DIALOG_BODY,
      dialogTitle: ResetLoginRateLimitingAction.DIALOG_TITLE,
      actionName: ResetLoginRateLimitingAction.ACTION_NAME,
      trigger: requestTrigger,
      actionSuccessCode: UserActionResultCode.userResetLoginRateLimiting
    };
    return new ConfirmationBasedAction(this.$translate, this.ConfirmActionDialog, this.userActionNotification,
      actionMetadata);
  }

  public onSiteUsers(context: IActionContext, siteUsers: Set<ISiteUser>): ng.IPromise<IResult> {
    return this.confirmationBasedSiteAction.runOn(context, siteUsers);
  }

  public onServerUsers(context: IActionContext, siteUsers: Set<IServerUser>): ng.IPromise<IResult> {
    return this.confirmationBasedServerAction.runOn(context, siteUsers);
  }
}

Module.instance().service('ResetLoginRateLimitingAction', ResetLoginRateLimitingAction);
